import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Login from '@/components/pages/Login';
import Index from '@/components/pages/Index';
import E404 from '@/components/pages/E404';
import PaymentList from '@/components/pages/modules/accounts/payments/PaymentList';
import Payment from '@/components/pages/modules/accounts/payments/Payment';
import PartnersBalances from '@/components/pages/modules/accounts/partners-balances/PartnersBalances';
import PurchaseContractsList from '@/components/pages/modules/purchases/contracts/PurchaseContractsList';
import PurchaseContract from '@/components/pages/modules/purchases/contracts/PurchaseContract';
import PurchaseLotsList from '@/components/pages/modules/purchases/lots/PurchaseLotsList';
import PurchaseOrdersList from '@/components/pages/modules/purchases/orders/PurchaseOrdersList';
import PurchaseOrder from '@/components/pages/modules/purchases/orders/PurchaseOrder';
import PurchaseInvoicesList from '@/components/pages/modules/purchases/invoices/PurchaseInvoicesList';
import PurchaseInvoice from '@/components/pages/modules/purchases/invoices/PurchaseInvoice';
import RequestList from '@/components/pages/modules/purchases/requests/RequestList';
import Request from '@/components/pages/modules/purchases/requests/Request';
import SalesContractsList from '@/components/pages/modules/sales/contracts/SalesContractsList';
import SalesContract from '@/components/pages/modules/sales/contracts/SalesContract';
import PartnersList from '@/components/pages/modules/general/partners/PartnersList';
import Partner from '@/components/pages/modules/general/partners/Partner';
import PricePolicy from '@/components/pages/modules/general/PricePolicy';
import DocumentsList from '@/components/pages/modules/general/documents/DocumentsList';
import Admin from '@/components/pages/modules/general/Admin';
import PackagesBinding from '@/components/pages/modules/purchases/binding/PackagesBinding';
import PurchaseOrderItemsList from '@/components/pages/modules/purchases/order-items/PurchaseOrderItemsList';
import SalesOrdersList from '@/components/pages/modules/sales/orders/SalesOrdersList';
import SalesOrder from '@/components/pages/modules/sales/orders/SalesOrder';
import Product from '@/components/pages/modules/general/products/Product';
import Operations from '@/components/pages/modules/manufacture/operations/Operations';
import Operation from '@/components/pages/modules/manufacture/operations/Operation';
import PacketsSearch from '@/components/pages/modules/manufacture/PacketsSearch';
import Reports from '@/components/pages/modules/manufacture/Reports';
import RawDistribution from '@/components/pages/modules/production-planning/raw-distribution/RawDistribution';
import OrderProducts from '@/components/pages/modules/production-planning/order-products/OrderProducts';
import SalesAgentInvoicesList from '@/components/pages/modules/agents/sales-invoices/SalesAgentInvoicesList';
import SalesAgentInvoice from '@/components/pages/modules/agents/sales-invoices/SalesAgentInvoice';
import SalesCommissionFeesList from '@/components/pages/modules/agents/sales-commission-fees/SalesCommissionFeesList';
import PaymentsAndInvoices from '@/components/pages/modules/sales/payments-and-invoices/PaymentsAndInvoicesList';
import FixedMargin from '@/components/pages/modules/sales/fixed-margin/FixedMargin';
import ProductsList from '@/components/pages/modules/general/products/ProductsList';
import SalesInvoicesList from '@/components/pages/modules/sales/invoices/SalesInvoicesList';
import SalesInvoice from '@/components/pages/modules/sales/invoices/SalesInvoice';
import DocumentsStorage from '@/components/pages/modules/general/documents-storage/DocumentsStorage';
import PurchaseCommissionFeesList from '@/components/pages/modules/agents/purchase-commission-fees/PurchaseCommissionFeesList';

const routes = [
  {
    path: '',
    name: 'index',
    component: Index,
    meta: {
      title: 'Home Page',
      routeName: 'index',
      breadcrumb: [
        {
          text: 'home_page'
        }
      ]
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login Page',
      routeName: 'login',
      breadcrumb: [
        {
          text: 'Login Page'
        }
      ]
    }
  },
  {
    name: 'payments',
    path: '/payments',
    component: PaymentList,
    meta: {
      title: 'Payments List',
      routeName: 'payments',
      breadcrumb: [
        {
          text: 'Payments'
        }
      ]
    }
  },
  {
    path: '/payments/:id',
    component: Payment,
    meta: {
      title: 'Payment',
      routeName: 'payments',
      breadcrumb: [
        {
          text: 'Payments',
          link: '/payments'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'partners-balances',
    path: '/partners-balances',
    component: PartnersBalances,
    meta: {
      title: 'Partners balances',
      routeName: 'partners-balances',
      breadcrumb: [
        {
          text: 'Partners balances'
        }
      ]
    }
  },
  {
    name: 'orderProducts',
    path: '/order-products',
    component: OrderProducts,
    meta: {
      title: 'Order Products',
      routeName: 'order_products',
      breadcrumb: [
        {
          text: 'Order Products'
        }
      ]
    }
  },
  {
    name: 'lots',
    path: '/lots',
    component: PurchaseLotsList,
    meta: {
      title: 'Lots And Specifications',
      routeName: 'purchase_lots',
      breadcrumb: [
        {
          text: 'LotsAndSpecifications'
        }
      ]
    }
  },
  {
    name: 'contracts',
    path: '/contracts',
    component: PurchaseContractsList,
    meta: {
      title: 'Contracts',
      routeName: 'purchase_contracts',
      breadcrumb: [
        {
          text: 'Contracts'
        }
      ]
    }
  },
  {
    path: '/contracts/:id',
    component: PurchaseContract,
    meta: {
      title: 'Contract',
      routeName: 'purchase_contracts',
      breadcrumb: [
        {
          text: 'Contracts',
          link: '/contracts'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'purchaseOrders',
    path: '/purchaseOrders',
    component: PurchaseOrdersList,
    meta: {
      title: 'Purchase Orders',
      routeName: 'purchase_orders',
      breadcrumb: [
        {
          text: 'PurchaseOrders'
        }
      ]
    }
  },
  {
    path: '/purchaseOrders/:id',
    component: PurchaseOrder,
    meta: {
      title: 'Purchase Order',
      routeName: 'purchase_orders',
      breadcrumb: [
        {
          text: 'PurchaseOrders',
          link: '/purchaseOrders'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'purchaseOrderItems',
    path: '/purchaseOrderItems',
    component: PurchaseOrderItemsList,
    meta: {
      title: 'Purchase Order Items',
      routeName: 'purchase_order_items',
      breadcrumb: [
        {
          text: 'PurchaseOrderItems'
        }
      ]
    }
  },
  {
    name: 'Purchase Invoices',
    path: '/purchase-invoices',
    component: PurchaseInvoicesList,
    meta: {
      title: 'Invoices',
      routeName: 'purchase_invoices',
      breadcrumb: [
        {
          text: 'Invoices'
        }
      ]
    }
  },
  {
    name: 'Purchase Invoice',
    path: '/purchase-invoice/:id?/:contract?/:supplier?/:receiving_date?/:movement_id?',
    component: PurchaseInvoice,
    meta: {
      title: 'Purchase Invoice',
      routeName: 'purchase_invoices',
      breadcrumb: [
        {
          text: 'Invoices',
          link: '/purchase-invoices'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'requests',
    path: '/requests',
    component: RequestList,
    meta: {
      title: 'Requests',
      routeName: 'special_orders',
      breadcrumb: [
        {
          text: 'Requests'
        }
      ]
    }
  },
  {
    path: '/requests/:id',
    component: Request,
    meta: {
      title: 'Request',
      routeName: 'special_orders',
      breadcrumb: [
        {
          text: 'Requests',
          link: '/requests'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'Packages_binding',
    path: '/binding',
    component: PackagesBinding,
    meta: {
      title: 'Packages Binding',
      routeName: 'packages_binding',
      breadcrumb: [
        {
          text: 'Packages_binding'
        }
      ]
    }
  },
  {
    path: '*',
    component: E404,
    meta: {
      title: 'Page Not Found',
      routeName: 'error'
    }
  },
  {
    name: 'salesContracts',
    path: '/sales-contracts',
    component: SalesContractsList,
    meta: {
      title: 'Sales Contracts List',
      routeName: 'sale_contracts',
      breadcrumb: [
        {
          text: 'Contracts'
        }
      ]
    }
  },
  {
    name: 'salesContract',
    path: '/sales-contracts/:id',
    component: SalesContract,
    meta: {
      title: 'Sales Contract',
      routeName: 'sale_contracts',
      breadcrumb: [
        {
          text: 'Contracts',
          link: '/sales-contracts'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'SalesOrders',
    path: '/sales-orders',
    component: SalesOrdersList,
    meta: {
      title: 'Orders List',
      routeName: 'sale_orders',
      breadcrumb: [
        {
          text: 'SalesOrders'
        }
      ]
    }
  },
  {
    name: 'Creating SalesOrder',
    path: '/sales-orders/:status/:id',
    component: SalesOrder,
    meta: {
      title: 'Order Creating',
      routeName: 'sale_orders',
      breadcrumb: [
        {
          text: 'SalesOrders',
          link: '/sales-orders'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'SalesOrder',
    path: '/sales-orders/:id',
    component: SalesOrder,
    meta: {
      title: 'Order',
      routeName: 'sale_orders',
      breadcrumb: [
        {
          text: 'SalesOrders',
          link: '/sales-orders'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'Sales Invoices',
    path: '/sales-invoices',
    component: SalesInvoicesList,
    meta: {
      title: 'Invoices List',
      routeName: 'invoices',
      breadcrumb: [
        {
          text: 'Sales Invoices'
        }
      ]
    }
  },
  {
    name: 'Sales Invoice',
    path: '/sales-invoice/:id?/:type?',
    component: SalesInvoice,
    meta: {
      title: 'Sales Invoice',
      routeName: 'invoices',
      breadcrumb: [
        {
          text: 'Sales Invoices',
          link: '/sales-invoices'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'Partner list',
    path: '/partners',
    component: PartnersList,
    meta: {
      title: 'Partners List',
      routeName: 'partners',
      breadcrumb: [
        {
          text: 'Partners'
        }
      ]
    }
  },
  {
    name: 'Partner',
    path: '/partners/:id',
    component: Partner,
    meta: {
      title: 'Partner',
      routeName: 'partners',
      breadcrumb: [
        {
          text: 'Partners',
          link: '/partners'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'Products',
    path: '/products',
    component: ProductsList,
    meta: {
      title: 'Products',
      routeName: 'products_search',
      breadcrumb: [
        {
          text: 'Products'
        }
      ]
    }
  },
  {
    name: 'Product',
    path: '/product/:id',
    component: Product,
    meta: {
      title: 'Product',
      routeName: 'product',
      breadcrumb: [
        {
          text: 'Products',
          link: '/products'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'Price policy',
    path: '/price-policy',
    component: PricePolicy,
    meta: {
      title: 'Price policy',
      routeName: 'price_policy',
      breadcrumb: [
        {
          text: 'Price policy'
        }
      ]
    }
  },
  {
    name: 'Operation',
    path: '/operation/:id',
    component: Operation,
    meta: {
      title: 'Operation',
      routeName: 'operations',
      breadcrumb: [
        {
          text: 'Operations search',
          link: '/operations'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'Operations',
    path: '/operations',
    component: Operations,
    meta: {
      title: 'Operations search',
      routeName: 'operations',
      breadcrumb: [
        {
          text: 'Operations search'
        }
      ]
    }
  },
  {
    name: 'Packet search',
    path: '/packets-search',
    component: PacketsSearch,
    meta: {
      title: 'Packets search',
      routeName: 'packets_search',
      breadcrumb: [
        {
          text: 'Packets search'
        }
      ]
    }
  },
  {
    name: 'Reports',
    path: '/reports',
    component: Reports,
    meta: {
      title: 'Reports',
      routeName: 'reports',
      breadcrumb: [
        {
          text: 'Reports'
        }
      ]
    }
  },
  {
    name: 'Documents',
    path: '/documents',
    component: DocumentsList,
    meta: {
      title: 'Documents',
      routeName: 'documents',
      breadcrumb: [
        {
          text: 'Documents'
        }
      ]
    }
  },
  {
    name: 'Admin',
    path: '/admin',
    component: Admin,
    meta: {
      title: 'Settings',
      routeName: 'settings',
      breadcrumb: [
        {
          text: 'Settings'
        }
      ]
    }
  },
  {
    name: 'Documents storage',
    path: '/documents-storage',
    component: DocumentsStorage,
    meta: {
      title: 'Documents storage',
      routeName: 'documents',
      breadcrumb: [
        {
          text: 'Documents storage'
        }
      ]
    }
  },
  {
    name: 'Raw Distribution',
    path: '/raw-distribution',
    component: RawDistribution,
    meta: {
      title: 'Raw Distribution',
      routeName: 'raw_distribution',
      breadcrumb: [
        {
          text: 'RawDistribution'
        }
      ]
    }
  },
  {
    name: 'Sales Agent Invoices ',
    path: '/sales-agent-invoices/',
    component: SalesAgentInvoicesList,
    meta: {
      title: 'Sales Agent Invoices',
      routeName: 'sale_agent_invoices',
      breadcrumb: [
        {
          text: 'AgentInvoices'
        }
      ]
    }
  },
  {
    name: 'Sales Commission Fees',
    path: '/sales-commission-fees/',
    component: SalesCommissionFeesList,
    meta: {
      title: 'Sales Commission Fees',
      routeName: 'sale_agent_comissions_fees',
      breadcrumb: [
        {
          text: 'SalesCommissionFees'
        }
      ]
    }
  },
  {
    name: 'Purchase Commission Fees',
    path: '/purchase-commission-fees/',
    component: PurchaseCommissionFeesList,
    meta: {
      title: 'Purchase Commission Fees',
      routeName: 'purchase_agent_comissions_fees',
      breadcrumb: [
        {
          text: 'PurchaseCommissionFees'
        }
      ]
    }
  },
  {
    name: 'Sales Agent Invoice',
    path: '/sales-agent-invoices/:id',
    component: SalesAgentInvoice,
    meta: {
      title: 'Sales Agent Invoice',
      routeName: 'sale_agent_invoices',
      breadcrumb: [
        {
          text: 'AgentInvoices',
          link: '/sales-agent-invoices'
        },
        {
          isChildRoute: true
        }
      ]
    }
  },
  {
    name: 'Fixed Margin',
    path: '/fixed-margin/',
    component: FixedMargin,
    meta: {
      title: 'Fixed Margin',
      routeName: 'fixed_margin',
      breadcrumb: [
        {
          text: 'Fixed Margin'
        }
      ]
    }
  },
  {
    name: 'Payments And Invoices',
    path: '/payments-invoices/',
    component: PaymentsAndInvoices,
    meta: {
      title: 'Payments And Invoices',
      routeName: 'payments_and_invoices',
      breadcrumb: [
        {
          text: 'Payments And Invoices'
        }
      ]
    }
  }
];

export const router = new VueRouter({
  routes,
  mode: 'history'
});



// WEBPACK FOOTER //
// ./src/routes/routes.js